import { useCallback, useLayoutEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";

import { useTooltipAutoClose, useTooltipPortalFade } from "../../../lib/useTooltipAutoClose";
import classes from "./BodySimpleModal.module.css";

// parent needs to have position relative !!!!!!

export default function BodySimpleModalV2({
    children,
    isDisabled,
    messages,
    normalEvent,
    isFlex,
    /** When nested in `WorkQDeferredTooltip`, used to locate the portaled tooltip for hover tracking. */
    tooltipBroadcastId,
}) {
    const messageRef = useRef(null);
    const tooltipElRef = useRef(null);
    const { isOpen, isVisible, isClosing, open, close } = useTooltipPortalFade();
    const [coordinates, setCoordinates] = useState({
        top: null,
        left: null,
    });

    const updateCoordinates = useCallback(() => {
        if (messageRef.current) {
            const rect = messageRef.current.getBoundingClientRect();
            setCoordinates({
                top: rect.top,
                left: rect.left + rect.width / 2,
            });
        }
    }, []);

    useLayoutEffect(() => {
        if (isOpen) {
            updateCoordinates();
        }
    }, [isOpen, updateCoordinates]);

    useTooltipAutoClose({
        isOpen,
        onClose: close,
        triggerRef: messageRef,
        tooltipRef: tooltipElRef,
        interactive: true,
    });

    const pointerEnterHandler = useCallback(() => {
        open();
        updateCoordinates();
    }, [open, updateCoordinates]);

    /** Lazy tooltip: outer wrapper mounts while pointer is already over the trigger — no `pointerover` fires on this node. */
    useLayoutEffect(() => {
        if (!messageRef.current) {
            return;
        }
        if (messageRef.current.matches(":hover")) {
            pointerEnterHandler();
        }
    }, [pointerEnterHandler]);

    const renderPortal = (htmlContent) => {
        const overlayRoot = document.getElementById("overlay-root");
        if (!isVisible || !overlayRoot || !messages?.length) {
            return null;
        }
        return ReactDOM.createPortal(
            <div
                ref={tooltipElRef}
                className={`${classes.fixed_message} ${isClosing ? classes.closing : ""}`}
                style={{ top: coordinates.top, left: coordinates.left }}
                onPointerEnter={pointerEnterHandler}
                onPointerLeave={close}
                {...(tooltipBroadcastId != null
                    ? { "data-tooltip-broadcast-id": tooltipBroadcastId }
                    : {})}
            >
                {messages.map((item) =>
                    htmlContent ? (
                        <div key={item} dangerouslySetInnerHTML={{ __html: item }} />
                    ) : (
                        <div key={item}>{item}</div>
                    ),
                )}
            </div>,
            overlayRoot,
        );
    };

    return (
        <>
            {isDisabled && messages && messages.length > 0 ? (
                <div
                    className={`${classes.fixed_message_container_v2} ${isFlex ? classes.flex_container : ""}`}
                    ref={messageRef}
                    onPointerEnter={pointerEnterHandler}
                >
                    {children}
                    {renderPortal(false)}
                </div>
            ) : (
                ""
            )}

            {normalEvent && messages && messages.length > 0 ? (
                <div
                    className={`${classes.fixed_message_container_normal_v2} ${isFlex ? classes.flex_container : ""}`}
                    ref={messageRef}
                    onPointerEnter={pointerEnterHandler}
                >
                    {children}
                    {renderPortal(true)}
                </div>
            ) : (
                ""
            )}
        </>
    );
}
